import * as types from '../../../../constants/ActionNameConstants';

const initialState = {
  loading: false,
  user: [],
  error: null,
};

const EditorDocumentReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.EDITOR_DOCUMENTS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case types.EDITOR_DOCUMENTS_SUCCESS:
      return {
        ...state,
        loading: false,
        user: action.payload,
      };
    case types.EDITOR_DOCUMENTS_FAILED:
      return {
        ...state,
        loading: false,
        error: action.error,
      };
    case types.RESET_EDITOR_DOCUMENTS_DATA: // Add this case to handle reset
      return {
        ...state,
        user: [], // Reset the user data to its initial state
        error: null, // Optionally, you can reset the error state as well
      };
    default:
      return state;
  }
};

export default EditorDocumentReducer;
